import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ratePerYear',
})
export class RatePerYearPipe implements PipeTransform {
  transform(unit: string, contractLenghtMonths: number): any {
    if (contractLenghtMonths > 12) {
      if (unit === '') {
        // if a unit is not proviced don't leave a space after the value => $200/year
        return `/year`;
      } else {
        // if a unit is provided leave a space after the value => 200 kWh/year
        return ` ${unit}/year`;
      }
    }

    return ` ${unit}`;
  }
}
